import { TextField } from "@fluentui/react";
import React, { useEffect } from "react";
import CustomPhoneInput from "../../../Hospital/components/ContactDetails/CustomPhoneInput";
import { t } from "i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PI from "react-phone-input-2";
import { ACTIONS } from "../../../../constants/Constants";
import MobileInput from "../../../../components/MobileInput";
const ReactPhoneInput = PI.default ? PI.default : PI;

const ContactDetailsRow = (props) => {
  return (
    <>
      {(props.action === ACTIONS.ADD || props.action === ACTIONS.EDIT) &&
        !props.editConfigurationSetting && (
          <section style={{ marginTop: "40px" }} id={props.id}>
            <div className="form-section-header">
              <p style={{ fontSize: "18px", padding: "5px 0px" }}>
                {props.headerName}
              </p>
            </div>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label={t("hospital.name")}
                  placeholder={t("hospital.name")}
                  name={`${props.name}.name`}
                  value={props.values?.name}
                  onBlur={props.handleBlur}
                  // onChange={props.handleChange}
                  // errorMessage={
                  // props.touched.contact1?.name && props.errors.contact1?.name
                  // }
                  onChange={(e) => {
                    props.handleChange(e);
                    if (
                      props.errorState.name.error != undefined ||
                      props.errorState.name.error != null
                    ) {
                      props.errorState.name.error = false;
                    }
                  }}
                  errorMessage={
                    props.checkError
                      ? props.errorState?.name?.error &&
                        props.errorState?.name?.msg
                      : false
                  }
                />
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label={t("hospital.type")}
                  placeholder={t("hospital.type")}
                  name={`${props.name}.type`}
                  value={props.values?.type}
                  onBlur={props.handleBlur}
                  //onChange={props.handleChange}
                  // errorMessage={
                  // props.touched.contact1?.type && props.errors.contact1?.type
                  // }
                  onChange={(e) => {
                    props.handleChange(e);
                    if (
                      props.errorState.type.error != undefined ||
                      props.errorState.type.error != null
                    ) {
                      props.errorState.type.error = false;
                    }
                  }}
                  errorMessage={
                    props.checkError
                      ? props.errorState?.type?.error &&
                        props.errorState?.type?.msg
                      : false
                  }
                />
              </div>

              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <TextField
                  className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  label={t("hospital.email")}
                  placeholder={t("hospital.email")}
                  name={`${props.name}.email`}
                  value={props.values?.email}
                  onBlur={props.handleBlur}
                  //onChange={props.handleChange}
                  // errorMessage={
                  // props.touched.contact1?.email && props.errors.contact1?.email
                  // }
                  onChange={(e) => {
                    props.handleChange(e);
                    if (
                      props.errorState.email.error != undefined ||
                      props.errorState.email.error != null
                    ) {
                      props.errorState.email.error = false;
                    }
                  }}
                  errorMessage={
                    props.checkError
                      ? props.errorState?.email?.error &&
                        props.errorState?.email?.msg
                      : false
                  }
                />
              </div>
              <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
                <CustomPhoneInput
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label={t("hospital.mobile")}
                  name={`${props.name}.mobile`}
                  value={props.values?.mobile}
                  errorState={props.errorState?.mobile?.error}
                  errorMessage = {props.errorState?.mobile?.msg}
                  checkError={props.checkError}
                  onChangeCustom={(value, data) => {
                    if (!value.startsWith("+")) {
                      value = "+" + value;
                    }
                    props.values.mobile = value;
                    props.values.mobileCountryCode = data.countryCode;
                    props.values.mobileDialCode = data.dialCode;
                    if (
                      props.errorState.mobile.error != undefined ||
                      props.errorState.mobile.error != null
                    ) {
                      props.errorState.mobile.error = false;
                    }
                  }}
                />
                {/* <MobileInput
                        name={`${props.name}.mobile`}
                        value={props.values?.mobile}
                        label={t("hospital.mobile")}
                        onChangeCustom={(value, data) => {
                          props.values.mobile = "+" + value;
                        }}
                        // touched={props.touched.contact1?.mobile}
                        // errorMessage={props.errors.contact1?.mobile}
                      /> */}
                <CustomPhoneInput
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
                  label={t("hospital.landline")}
                  name={`${props.name}.landline`}
                  value={props.values?.landline}
                  errorState={props.errorState?.landline?.error}
                  errorMessage={props.errorState?.landline?.msg}
                  checkError={props.checkError}
                  onChangeCustom={(value, data) => {
                    if (!value.startsWith("+")) {
                      value = "+" + value;
                    }
                    props.values.landline = value;
                    props.values.landlineCountryCode = data.countryCode;
                    props.values.landlineDialCode = data.dialCode;
                    if (
                      props.errorState.landline.error != undefined ||
                      props.errorState.landline.error != null
                    ) {
                      props.errorState.landline.error = false;
                    }
                  }}
                />
                {/* <MobileInput
                        label={t("hospital.landline")}
                        name={`${props.name}.landline`}
                        value={props.values?.landline}
                        onChangeCustom={(value, data) => {
                          props.values.landline = "+" + value;
                        }}
                        // touched={props.touched.contact1?.landline}
                        // errorMessage={props.errors.contact1?.landline}
                      /> */}
              </div>
            </div>
          </section>
        )}
      {(props.action === ACTIONS.VIEW || props.editConfigurationSetting) && (
        <section style={{ marginTop: "40px" }} id={props.id}>
          <div className="form-section-header">
            <p style={{ fontSize: "18px", padding: "5px 0px" }}>
              {props.headerName}
            </p>
          </div>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.name")}</div>
                <div className="form-mt-10">
                  {props.values?.name ? props.values.name : "-"}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.type")}</div>
                <div className="form-mt-10">
                  {props.values?.type ? props.values?.type : "-"}
                </div>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
                <div className="form-heading">{t("hospital.email")}</div>
                <div className="form-mt-10">
                  {props.values?.email ? props.values?.email : "-"}
                </div>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "20px" }}>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.mobile")}</div>
                <div className="form-mt-10">
                  {props.values?.mobile ? props.values?.mobile : "-"}
                </div>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6">
                <div className="form-heading">{t("hospital.landline")}</div>
                <div className="form-mt-10">
                  {props.values?.landline ? props.values?.landline : "-"}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ContactDetailsRow;
